import { FiMenu } from "react-icons/fi";
import { CountDownTimer } from "../count-down-timer";

const Header = ({ 
  showLogo, 
  countdownTarget 
}: { 
  showLogo: boolean; 
  countdownTarget?: Date | null;
}) => {
  // Use the provided countdownTarget or fallback to default (72 hours from now)
  const targetDate = countdownTarget || new Date(Date.now() + 72 * 60 * 60 * 1000);

  return (
    <div className="h-[376px] md:h-[548px] bg-[url('/images/hero_bg2.png')] bg-cover bg-center">
      <header className="container mx-auto h-[154px] md:h-[232px] p-10 md:p-4">
        <nav>
          <div className="flex items-center justify-between">
            <FiMenu className="w-[38px] h-[38px] text-white" />
            {showLogo && (
              <div className="absolute left-1/2 mt-3.5 md:mt-0 -translate-x-1/2 md:static md:translate-x-0">
                <img
                  src="/images/vac_logo.png"
                  alt="VAC Logo"
                  width={232}
                  height={232}
                  className="size-[154px] md:size-[232px]"
                />
              </div>
            )}
            <div className="hidden md:block relative w-[153px] border-l-2 border-[#D9D9D9]">
              <div className="ml-2 text-white text-left flex flex-col justify-center">
                <span className="text-lg font-kalameh font-light">واک</span>
                <span className="text-lg font-kalameh font-light">
                  دانشگاه و
                </span>
                <span className="text-lg font-kalameh font-light">
                  باشگاه صدا
                </span>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <div className="flex flex-col items-center">
        <CountDownTimer targetDate={targetDate} />
        <p className="text-[24px] md:text-[48px] font-kalameh font-medium text-white">
          مهلت مانده تا دسترسی رایگان
        </p>
      </div>
    </div>
  );
};

export default Header;
